import { MinusIcon, PlusIcon } from '../assets/svgImages';
import { AccordionProps } from '../interface/interface';
import { SyntheticEvent } from 'react';

const Accordion = ({
  title,
  children,
  isOpen,
  onAccordionToggle,
}: AccordionProps) => {
  const AccordionSmartClick = (e: SyntheticEvent) => {
    const isButtonOrSelect = (e.target as HTMLElement).closest(
      '.status-dropdown,button',
    );
    if (isButtonOrSelect) {
      e.stopPropagation();
    } else {
      onAccordionToggle();
    }
  };

  return (
    <div className="bg-white shadow-normal rounded-lg border border-grey-200 mb-2.5">
      <div
        className="flex justify-between items-center p-4 cursor-pointer relative w-full"
        onClick={AccordionSmartClick}
        data-testid="accordionSmartClick"
      >
        <div className="w-full">{title}</div>
        <div className="absolute top-2.5 right-2.5">
          {isOpen ? (
            <MinusIcon className="h-5 w-5" />
          ) : (
            <PlusIcon className="h-5 w-5" />
          )}
        </div>
      </div>
      {isOpen && <div className="sm:px-4 md:p-4 sm:mb-4">{children}</div>}
    </div>
  );
};

export default Accordion;
